const axios = require("axios").default;

const CUSTOMER_URL = `${process.env.REACT_APP_API_URL}/customer`;

export const getCustomer = (payload) => {
  return axios.get(CUSTOMER_URL, {
    params: payload,
  });
};
